<template>
  <div class="leftMenu">
    <li
      @click="gotoHandle(leftItem.anchorId)"
      :class="[
        'menu-item',
        isActiveInner === leftItem.anchorId ? 'menu-item--active' : ''
      ]"
      v-for="(leftItem, idx) in leftMenus"
      :key="idx"
    >
      {{ leftItem.title }}
      <div class="articleTitle">
        {{ leftItem.articleTitle }}
      </div>
    </li>
  </div>
</template>

<script>
export default {
  name: "NewsMenu",
  props: {
    isActive: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      leftMenus: [
        {
          title: "Aug 04, 2021",
          anchorId: "Aug202104",
          articleTitle: "Celebrating ToTok’s 2nd Anniversary"
        },
        {
          title: "May 11, 2021",
          anchorId: "May202111",
          articleTitle: "Celebrate EID with ToTok!"
        },
        {
          title: "Aug 4, 2020",
          anchorId: "oneYear",
          articleTitle: this.$t('news.one_year.title')
        },
        {
          title: "Jun 15, 2020",
          anchorId: "Jun202015",
          articleTitle: "Introducing New Features on ToTok"
        },
        {
          title: "May 21, 2020",
          anchorId: "EidiyaToTok",
          articleTitle: "Send your Eidiya through ToTok!"
        },
        {
          title: "April 29, 2020",
          anchorId: "newsApr202029",
          articleTitle: "Celebrate Ramadan and stay connected with ToTok"
        },
        {
          title: "Mar 23, 2020",
          anchorId: "newsMar202023",
          articleTitle: "PayBy is now live on ToTok in the UAE"
        },
        {
          title: "Mar 11, 2020",
          anchorId: "newsMar202011",
          articleTitle:
            "ToTok Media Statement: A Call for Cooperation with Apple and Google"
        },
        {
          title: "Mar 05, 2020",
          anchorId: "newsMar202005",
          articleTitle: "“Coronavirus Live Updates” is now available on ToTok"
        },
        {
          title: "Feb 23, 2020",
          anchorId: "newsFeb20200223",
          articleTitle: "Message to our ToTok community"
        },
        {
          title: "Feb 20, 2020",
          anchorId: "Feb202020",
          articleTitle: "A note to the ToTok community from our cofounders"
        },
        {
          title: "Jan 05, 2020",
          anchorId: "Jan05",
          articleTitle: "ToTok is back on Google Play"
        },
        {
          title: "Dec 29, 2019",
          anchorId: "Dec29",
          articleTitle:
            "ToTok cofounder’s exclusive interview with Khaleej Times"
        },
        {
          title: "Dec 27, 2019",
          anchorId: "Dec27",
          articleTitle: "Message to Apple and Google from our cofounder"
        },
        {
          title: "Dec 24, 2019",
          anchorId: "Dec24",
          articleTitle: "A note from the ToTok cofounders"
        },
        {
          title: "Dec 23, 2019",
          anchorId: "Dec23",
          articleTitle: "A letter to the ToTok community"
        }
      ]
    };
  },
  computed: {
    isActiveInner: {
      get() {
        return this.isActive;
      },
      set() {
        return this.isActive;
      }
    }
  },
  methods: {
    gotoHandle(palice) {
      console.log("palice", palice);
      switch (palice) {
        case "Aug202104":
          this.isActiveInner = "Aug202104";
          this.$router.push({ name: "Aug202104" });
          break;
        case "May202111":
          this.isActiveInner = "May202111";
          this.$router.push({ name: "May202111" });
          break;
        case "oneYear":
          this.isActiveInner = "oneYear";
          this.$router.push({ name: "one-year" });
          break;
        case "Jun202015":
          this.isActiveInner = "Jun202015";
          this.$router.push({ name: "Jun202015" });
          break;
        case "EidiyaToTok":
          this.isActiveInner = "EidiyaToTok";
          this.$router.push({ name: "EidiyaToTok" });
          break;
        case "newsApr202029":
          this.isActiveInner = "newsApr202029";
          this.$router.push({ name: "newsApr202029" });
          break;
        case "newsMar202023":
          this.isActiveInner = "newsMar202023";
          this.$router.push({ name: "newsMar202023" });
          break;
        case "newsMar202011":
          this.isActiveInner = "newsMar202011";
          this.$router.push({ name: "newsMar202011" });
          break;
        case "newsMar202005":
          this.isActiveInner = "newsMar202005";
          this.$router.push({ name: "newsMar202005" });
          break;
        case "newsFeb20200223":
          this.isActiveInner = "newsFeb20200223";
          this.$router.push({ name: "newsFeb20200223" });
          break;
        case "Feb202020":
          this.isActiveInner = "Feb202020";
          this.$router.push({ name: "newsFeb202020" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Jan05":
          this.isActiveInner = "Jan05";
          this.$router.push({ name: "newsJan05" });
          break;
        case "Dec29":
          this.isActiveInner = "Dec29";
          this.$router.push({ name: "newsDec29" });
          break;
        case "Dec27":
          this.isActiveInner = "Dec27";
          this.$router.push({ name: "newsDec27" });
          break;
        case "Dec24":
          this.isActiveInner = "Dec24";
          this.$router.push({ name: "newsDec24" });
          break;
        case "Dec23":

      }
    }
  }
};
</script>

<style scoped lang="stylus">
@media only screen and (max-width: 700px) {
    .leftMenu {
       display none
    }
}
@media only screen and (min-width: 701px) {
    .leftMenu {
       position: absolute;
       left: 0px;
       top: 39px;
       width: 260px;
       text-align: left;
       display flex;
       flex-direction column;
       justify-content center;
       align-items: flex-start;
       list-style none;

       .menu-item {
           color: #4378f2;
           margin-top: 30px;
           font-size: 12px;
           font-weight: 500;
           letter-spacing: 1px;
           cursor pointer;
           text-decoration none;
           .articleTitle{
               font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
               font-size: 14px;
               color: #414141;
               width: 80%;
               line-height: 1.3;
               margin-top: 7px;
               letter-spacing: 1px;
           }
       }

       .menu-item:nth-child(1) {
           margin-top: 0px;
       }

       .menu-item--active {
           color: #4378f2;
           .articleTitle{
               color: #4377f2;
               font-weight: 400;
               letter-spacing: 1px;
           }
       }

   }
}
</style>
